import React from "react";
import "./MegaMenu2.css";

export default function MegaMenuFeatures() {
  const Icon = ({ d }) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d={d} stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );

  const DashboardIcon = () => <Icon d="M4 4h16v16H4z" />;
  const QueryIcon = () => <Icon d="M4 6h16M4 12h10M4 18h7" />;
  const SegregationIcon = () => <Icon d="M12 2v20M2 12h20" />;
  const CubeIcon = () => <Icon d="M12 2l8 4v8l-8 4-8-4V6z" />;
  const UsageIcon = () => <Icon d="M4 12l4 4 8-8" />;
  const BotIcon = () => <Icon d="M9 3h6v3H9zM5 9h14v10H5z" />;

  const SdkIcon = () => <Icon d="M4 4h16v16H4z" />;
  const PaletteIcon = () => (
    <Icon d="M12 3a9 9 0 100 18 2 2 0 002-2c0-1-.5-2-1.5-2h-1" />
  );
  const DrillIcon = () => <Icon d="M10 10l8 8M6 6l4 4" />;
  const SqlIcon = () => <Icon d="M4 7h16M4 12h16M4 17h16" />;
  const LockIcon = () => <Icon d="M6 10V7a6 6 0 1112 0v3" />;
  const UploadIcon = () => <Icon d="M12 16V4M8 8l4-4 4 4M4 20h16" />;

  const SparkleIcon = () => <Icon d="M12 2l2 4 4 2-4 2-2 4-2-4-4-2 4-2z" />;
  const MapIcon = () => <Icon d="M4 6l6-2 4 2 6-2v14l-6 2-4-2-6 2z" />;

  return (
    <div className="mega-menu mega-menu--features">
      <div className="mega-menu-inner">
        {/* Feature grid */}
        <div className="mega-features">
          <div className="feature-column">
            <FeatureItem
              icon={<DashboardIcon />}
              label="Dashboards and reporting"
            />
            <FeatureItem icon={<QueryIcon />} label="Lorem Ipsum 1" />
            <FeatureItem icon={<SegregationIcon />} label="Lorem Ipsum 2" />
            <FeatureItem icon={<CubeIcon />} label="Lorem Ipsum 3" />
            <FeatureItem icon={<UsageIcon />} label="Lorem Ipsum 4" />
            <FeatureItem icon={<BotIcon />} label="Lorem Ipsum 5" />
          </div>

          <div className="feature-column">
            <FeatureItem icon={<SdkIcon />} label="Lorem Ipsum 6" />
            <FeatureItem icon={<PaletteIcon />} label="Lorem Ipsum 7" />
            <FeatureItem icon={<DrillIcon />} label="Lorem Ipsum 8" />
            <FeatureItem icon={<SqlIcon />} label="Lorem Ipsum 9" />
            <FeatureItem icon={<LockIcon />} label="Lorem Ipsum 10" />
            <FeatureItem icon={<UploadIcon />} label="Lorem Ipsum 11" />
          </div>
        </div>

        {/* Footer actions */}
        <div className="mega-footer">
          <FooterAction icon={<SparkleIcon />} label="Placeholder 1" />
          <FooterAction icon={<MapIcon />} label="Placeholder 2" />
        </div>
      </div>
    </div>
  );
}

/* ---------- Subcomponents ---------- */

function FeatureItem({ icon, label }) {
  return (
    <div className="feature-item">
      <span className="feature-icon">{icon}</span>
      <span className="feature-label">{label}</span>
    </div>
  );
}

function FooterAction({ icon, label }) {
  return (
    <div className="footer-action">
      <span className="footer-icon">{icon}</span>
      <span>{label}</span>
    </div>
  );
}
